import { KText } from '@/ui-library/components/text';
import { Flex, Icon } from '@chakra-ui/react';
import { FaceSad } from '@kula-ai/icons-core';

interface SchInterviewersInfoProps {
  variant: string;
  interviewKind: string;
  value: { length: number }[] | undefined;
  bookedSlot: any;
  localInterviewers: string[] | number[] | undefined;
}

export const SchInterviewersInfo = ({
  bookedSlot,
  localInterviewers,
}: SchInterviewersInfoProps) => {
  const { interviewerStatus, isOriginalSlotModified } =
    bookedSlot?.extendedProps ?? {};

  const showErrorCondition =
    Array.isArray(localInterviewers) &&
    interviewerStatus &&
    !isOriginalSlotModified;

  let loadExceeded = false;
  let unavailable = false;

  if (showErrorCondition) {
    loadExceeded = localInterviewers.some((interviewer) => {
      const { has_exceeded_max_workload = false } =
        interviewerStatus?.[interviewer] ?? {};
      return has_exceeded_max_workload;
    });

    unavailable = localInterviewers.some((interviewer) => {
      const { is_unavailable = false } = interviewerStatus?.[interviewer] ?? {};
      return is_unavailable;
    });
  }

  let title: string | undefined;
  let description: string | undefined;
  const MessageIconComponent: any = FaceSad;

  const hasMoreThanOneInterviewer =
    Array.isArray(localInterviewers) && localInterviewers.length > 0;

  if (loadExceeded) {
    title = hasMoreThanOneInterviewer
      ? 'Interviewers’ weekly interview load exceeded'
      : "Interviewer's weekly interview load exceeded";
    description = hasMoreThanOneInterviewer
      ? 'Remove them, pick other interviewers or schedule it on a different week'
      : 'Pick another interviewer or schedule it on a different week';
  } else if (unavailable) {
    if (hasMoreThanOneInterviewer) {
      title = 'Interviewers are not available';
    } else {
      title = 'Interviewer is not available';
    }
    description = hasMoreThanOneInterviewer
      ? 'Remove them, pick other interviewers or schedule it on a different day or time'
      : 'Pick another interviewer or schedule it on a different day or time';
  }

  if (!title) {
    return null;
  }

  return (
    <Flex
      flexDir="column"
      gap="8px"
      mt="12px"
      bgColor="secondary-50"
      borderRadius="6px"
      p="12px"
      pr="5px"
    >
      <Flex gap="6px" alignItems="center">
        {MessageIconComponent && (
          <Icon
            w="20px"
            h="20px"
            as={MessageIconComponent}
            color="secondary-700"
          />
        )}
        <KText variant="heading_4">{title}</KText>
      </Flex>
      <KText>{description}</KText>
    </Flex>
  );
};
